import PlanService from "../../services/PlanService";

export function validate({ commit }, identificador) {
  return new Promise((resolve, reject) => {
    PlanService.validate(identificador)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function search({ commit }) {
  return new Promise((resolve, reject) => {
    PlanService.search()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function searchPlan ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    PlanService.searchPlan(payload.user, payload.value)
        .then(response => {
            resolve(response)
        })
        .catch(response => {
            reject(response)
        })
  })
}

export function createPlan ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    PlanService.createPlan(payload)
        .then(response => {
            resolve(response)
        })
        .catch(response => {
            reject(response)
        })
  })
}

export function consulta ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    PlanService.consulta(payload)
        .then(response => {
            resolve(response)
        })
        .catch(response => {
            reject(response)
        })
  })
}

export function videoconferencia ({ commit }, payload) {
  return new Promise((resolve, reject) => {
    PlanService.videoconferencia(payload)
        .then(response => {
            resolve(response)
        })
        .catch(response => {
            reject(response)
        })
  })
}
